import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import _ from 'lodash';
import qs from 'qs';

import { GET_CLASS_TREE_DATA } from '../graphql/queries/general';

const API_URL =
  process.env.REACT_APP_GEE_API_URL ||
  'https://staging.api.mapbiomas.org/api/v1/brazil';

const customSubmoduleProps = {
  coverage_main: {
    year: ({ activeYear }) => {
      if (_.isArray(activeYear)) {
        return _.last(activeYear);
      } else {
        return activeYear;
      }
    },
    territoryIds: ({ territoryId }) => ([territoryId]),
    legend: () => 'default',
  },
  coverage_rgb: {
    year: ({ activeYear }) => {
      if (_.isArray(activeYear)) {
        return _.last(activeYear);
      } else {
        return activeYear;
      }
    },
    territoryIds: ({ territoryId }) => ([territoryId]),
  },
  sentinel_mosaic: {
    year: ({ activeYear }) => {
      if (_.isArray(activeYear)) {
        return _.last(activeYear);
      } else {
        return activeYear;
      }
    },
    month: ({ activeMonth }) => {
      return activeMonth;
    },
  },
};

export default function useGenericBaseLayer(params) {
  const {
    pathKey,
    layer,
    bbox,
    bboxSize,
    hasDefaultPixelValues,
  } = params;

  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const { data: defaultClassTreeData } = useQuery(GET_CLASS_TREE_DATA, {
    variables: {
      classTreeKey: 'default'
    },
  });
  const defaultClassTreeNodes = _.get(defaultClassTreeData, 'classTreeByKey[0].mvClassTreeLevelsUi');

  const customProps = customSubmoduleProps[pathKey] || {};
  const parsedCustomParams = _.reduce(
    customProps,
    (obj, paramFormatter, paramKey) => {
      if (_.isFunction(paramFormatter)) {
        obj[paramKey] = paramFormatter(params);
      } else if (_.isString(paramFormatter)) {
        obj[paramKey] = _.get(params, paramFormatter);
      } else {
        return obj;
      }
      return obj;
    },
    {}
  );

  let parsedParams = {
    initiative: 'brazil',
    ...parsedCustomParams,
  };

  if (pathKey === 'layer') {
    parsedParams['layer'] = layer;
  }

  if (bbox && bboxSize) {
    parsedParams['bbox'] = bbox;
    parsedParams['bboxSize'] = bboxSize;
  }

  if (hasDefaultPixelValues) {
    parsedParams['pixelValues'] = _.filter(
      _.map(defaultClassTreeNodes, 'pixelValue'),
      _.isNumber
    );
  }

  const mapUrl = `${ API_URL }/maps/${ pathKey }?${qs.stringify(
    parsedParams,
    { arrayFormat: 'repeat' }
  )}`;

  useEffect(() => {
    const hasBBox = _.includes(mapUrl, 'bbox');

    setLoading(true);
    fetch(mapUrl, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        if (!hasBBox) {
          return response.text();
        } else {
          return response.blob();
        }
      })
      .then((data) => {
        if (!hasBBox) {
          setUrl(data);
        } else {
          const imgURL = URL.createObjectURL(data);

          setUrl(imgURL);
        }
        setLoading(false);
      });
  }, [mapUrl]);

  return {
    loading,
    url,
  };
}
